import { Grid } from "@mui/material";
import { toNumber } from "lib/math";
import React from "react";
import CustomProgressBar from "./CustomProgressBar";
import CustomText from "./typography/CustomText";

export default function SimpleProgressCard({
  title = "",
  action = "",
  value = 0,
  percentText = "",
}) {
  action =
    typeof action === "string" ? (
      <CustomText bold={600} color="secondary">
        {action}
      </CustomText>
    ) : (
      action
    );
  return (
    <div>
      <Grid container spacing={1} justifyContent="space-between">
        <Grid className="flex justify-between w-full" item>
          <CustomText color="secondary">{title ?? ""}</CustomText>
          {Boolean(percentText) ? (
            <CustomText color="secondary">{percentText ?? ""}</CustomText>
          ) : null}
        </Grid>
        <Grid item>{action}</Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <CustomProgressBar variant="simple" value={toNumber(value)} />
        </Grid>
      </Grid>
    </div>
  );
}
